<script setup lang="ts">
import { Asignatura } from '@shared/types'
import { computed } from 'vue'

const props = defineProps<{ asignaturas: { [key: string]: Asignatura } }>()
const asignaturasFiltered = computed(() =>
	Object.values(props.asignaturas)
		.filter(asignatura => asignatura !== undefined && asignatura !== null)
		.sort((a, b) => {
			if (a.order === undefined && b.order === undefined) return 0
			if (a.order === undefined) return 1
			if (b.order === undefined) return -1
			return a.order - b.order
		})
)
</script>

<template>
	<table class="subject-table">
		<thead>
			<tr>
				<th>Asignatura</th>
				<th>Clave</th>
				<th>ID</th>
				<th>Créditos</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="asignatura in asignaturasFiltered" :key="asignatura.idAsignatura">
				<td>{{ asignatura.nombre.toLocaleUpperCase() || 'Sin Nombre' }}</td>
				<td>{{ asignatura.claveAsignatura || 'Sin Clave' }}</td>
				<td>{{ asignatura.idAsignatura || 'Sin ID' }}</td>
				<td>{{ asignatura.creditos || 0 }}</td>
			</tr>
		</tbody>
	</table>
</template>

<style scoped>
.subject-table {
	width: 100%;
	border-collapse: collapse;
	background: #fff;
}
.subject-table th,
.subject-table td {
	border: 1px solid #e0e6ed;
	padding: 10px 12px;
	text-align: left;
}
.subject-table th {
	background: #f0f4fa;
	font-weight: 600;
}
.subject-table tr:nth-child(even) td {
	background: #fafbfc;
}
</style>
